// Charge la base commune
import './common.js'

// Scripts librairies
import { dtectMap } from './js/libs/utils'
/* global Waypoint */
import 'waypoints/lib/jquery.waypoints.min.js'

// Styles custom
import './scss/pages/agencies'

// Pages
import { agenciesPage } from './js/pages/agencies.page.js'

// rafraîchissement
function r () {
  Waypoint.refreshAll()
}

// Contact Form
async function getContactForm ($f) {
  import(/* webpackChunkName: "contact-form" */ './js/components/contact-form.js').then(() => {
    $f.load(false)
    r()
  })
}

// OwlCarousel
async function getOwlCarousel () {
  import(/* webpackChunkName: "owl-carousel" */ './js/components/owl-carousel.js').then(() => {
    r()
  })
}

// Agency autocomplete
async function getAgencyAutocomplete ($f) {
  import(/* webpackChunkName: "quick-agency-search-form" */ './js/components/quick-agency-search-form.js').then(module => {
    const form = module.qasForm
    form.init($f)
  })
}

// Custom Lists
async function getCustomLists () {
  import(/* webpackChunkName: "custom-lists" */ './js/components/custom-lists.js').then(() => {
    r()
  })
}

// Quick Offers Search Form
async function getQosForm ($f) {
  import(/* webpackChunkName: "quick-offers-search-form" */ './js/components/quick-offers-search-form.js').then(() => {
    $f.load(false)
    // console.log('quick-offers-search-form')
  })
}

// Offer autocomplete
async function getOfferAutocomplete ($f) {
  import(/* webpackChunkName: "offer-autocomplete" */ './js/components/offer-autocomplete.js').then(module => {
    const form = module.offersAutocomplete
    form.init($f)
  })
}

// Pajination
async function getPajination () {
  import(/* webpackChunkName: "pajination" */ './js/components/pajination.js').then(() => {
    r()
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // gestion du formulaire de contact
  const $f = $('.contact-form')
  if ($f.length) {
    $f.waypoint(function () {
      $f.load()
      getContactForm($f)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion des carousel
  const $d = $('.owl-carousel.c')
  if ($d.length) {
    $d.waypoint(function () {
      getOwlCarousel()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion des scrollbars améliorées
  const $c = $('.custom-lists')
  if ($c.length) {
    $c.waypoint(function () {
      getCustomLists()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion du formulaire de recherche des offres
  const $e = $('.qosForm.in')
  if ($e.length) {
    $e.waypoint(function () {
      $e.load()
      getQosForm($e)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion des scrollbars améliorées
  const $p = $('.pajinate')
  if ($p.length) {
    $p.waypoint(function () {
      getPajination()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // filtres des agences autocomplete
  $('form[name="qasForm"] input[name="search"]').on('click', function () {
    $(this).blur().off('click').attr('disabled', '')
    getAgencyAutocomplete($(this).parents('form'))
  })

  // filtres des offres autocomplete
  $('form[name="qosForm"] input[name="search"]').on('click', function () {
    $(this).blur().off('click').attr('disabled', '')
    getOfferAutocomplete($(this).parents('form'))
  })

  // à exécuter une fois la GMap API correctement chargée
  dtectMap(function () {
    agenciesPage.init()
  })
})
